export { IDS, H1, SEO_TITLE, SEO_DESCRIPTION } from './constants'
// TODO: fix the eslint-disable-next-line
// eslint-disable-next-line
export type { THomePageProps } from './types'
